<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader">
      </loading>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-toolbar">
                <div>
                    <h4 class="text-primary">Retur</h4>
                    <ol class="breadcrumb breadcrumb-card-header">
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0);" @click="backParent">Invoice</a>
                    </li>
                    <li class="breadcrumb-item active">
                        <!-- <span v-if="delivery.id === null">New</span> -->
                        <!-- <span v-else>{{ delivery.deliver_no }}</span> -->
                    </li>
                    </ol>
                    <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
                    <button v-if="dataReturn.id === null" type="button" @click="createRetur" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-mail-forward" aria-hidden="true"></i> Process</button>
                    <button v-else type="button" @click="updateRetur" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-mail-forward" aria-hidden="true"></i> Update</button>
                    <!-- <button class="btn btn-sm btn-soft-primary pull-left" @click="createReturP">Purchasing</button> -->
                    <button class="btn btn-sm btn-soft-danger pull-left" @click="createScrap"><i class="fa fa-trash"></i> Scrap</button>
                    <button class="btn btn-sm btn-info pull-left" @click="printRetur"><i class="fa fa-print"></i> Print</button>
                    <button class="btn btn-sm btn-soft-primary pull-left" @click="setCOGSAll"><i class="fa fa-refresh"></i> Set COGS</button>
                    <!-- <button v-else type="button" @click="updateDelivery" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-save" aria-hidden="true"></i> Update</button> -->
                </div>
                </div>
            </div>
        </div>
        <div class="card card-list">
            <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <strong class="font-24">Retur Data:</strong>
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-4">Retur No.</dt>
                      <dd class="col-md-8">
                        <span v-if="dataReturn.return_no === null">New</span>
                        <span v-else>{{ dataReturn.return_no }}</span>
                      </dd>
                    </dl>
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-4">Date</dt>
                      <dd class="col-md-8">
                        <datetime v-model="dataReturn.return_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                      </dd>
                    </dl>
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-4">Notes</dt>
                      <dd class="col-md-8">
                        <textarea rows="5" v-model="dataReturn.notes" class="form-control form-control-list"/>
                      </dd>
                    </dl>
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-4">Tax</dt>
                      <dd class="col-md-8">
                        <select v-model="dataReturn.tax_id" class="form-control form-control-lite" @change="setTax">
                          <option v-for="t in taxList" :key="t.id" :value="t.id">Tax: {{ t.name }}</option>
                        </select>
                      </dd>
                    </dl>
                  </div>
                  <div class="col-md-4">
                      <div class="float-left">
                      <address class="font-13">
                          <strong class="font-24">Customer</strong>
                          <br><b>{{ sales.customer.name }}</b>
                          <br>{{ sales.customer.phone }}
                          <br><b>{{ sales.customer.address}}</b>
                      </address>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="float-left">
                      <address class="font-13">
                          <strong class="font-24">Sales</strong>
                          <br><b  class="font-16">{{ sales.sale_no }}</b>
                          <br>{{ sales.sale_date | dateFormat('DD/MM/YYYY')}}
                          <br>{{ sales.salesman }}
                          <br><b>{{ sales.taxes }}</b>
                          <br>{{ sales.price_list }}
                      </address>
                      </div>
                  </div>
                </div>
                <hr class="mt-5 mb-5">
                <div class="row">
                    <div class="col-md-5">
                        <strong class="font-24">Product</strong>
                        <div class="table-responsive">
                            <table class="table table-item table-sm table-striped">
                                <thead>
                                    <th>Product</th>
                                    <th>Qty</th>
                                    <th>Price</th>
                                    <th>Discount</th>
                                    <th>Tax</th>
                                    <th>COGS</th>
                                    <th>Total</th>
                                    <th>#</th>
                                </thead>
                                <tbody>
                                <tr v-for="(d, index) in sales.details" :key="index">
                                    <td><b>[{{ d.product_no }}]</b> {{ d.description }}</td>
                                    <td>{{ d.qty }}</td>
                                    <td>{{ d.price }}</td>
                                    <td>{{ d.discount | currency }}</td>
                                    <td>{{ d.tax | currency }}</td>
                                    <td>{{ d.cost | currency }}</td>
                                    <td>{{ d.total | currency }}</td>
                                    <td>
                                        <button type="button" class="btn btn-sm btn-outline-primary" @click="addToReturn(index)"><i class="fa fa-share"></i></button>
                                    </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td><b>Discount:</b></td>
                                  <td class="text-right">{{ sales.discount | currency }}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td><b>Tax:</b></td>
                                  <td class="text-right">{{ sales.tax | currency }}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td><b>Total:</b></td>
                                  <td class="text-right">{{ sales.total | currency }}</td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <strong class="font-24">Retur Product:</strong>
                        <div class="table-responsive">
                            <table class="table table-item table-sm table-striped">
                                <thead>
                                    <th>Product No.</th>
                                    <th>Product</th>
                                    <th>Warehouse</th>
                                    <th>Qty</th>
                                    <th>Uom</th>
                                    <th>Notes</th>
                                    <th>Amount</th>
                                    <th>Tax</th>
                                    <th>Total</th>
                                    <th>#</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(r, index) in salesReturn" :key="index">
                                        <td><b>{{ r.product_no }}</b></td>
                                        <td>{{ r.product }}</td>
                                        <td>{{ r.warehouse_no }}</td>
                                        <td>
                                            <input type="text" class="form-control" v-model="r.qty" @keyup="calcrow(index)"/>
                                        </td>
                                        <td>{{ r.uom_id }}</td>
                                        <td>
                                          <textarea class="form-control" v-model="r.notes" :disabled="r.lock"></textarea>
                                        </td>
                                        <td>
                                            <input type="type" class="form-control" v-money="money" v-model="r.amount" />
                                        </td>
                                        <td>{{ r.tax | currency }} ({{ r.taxes }})</td>
                                        <td class="text-right">{{ r.total | currency }}</td>
                                        <td>
                                            <button type="button" class="btn btn-sm btn-outline-danger" @click="removeReturn(index)"><i class="fa fa-trash"></i></button>
                                        </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" class="text-right"><b>subtotal</b></td>
                                      <td class="text-right">{{ totalSubtotalDetailReturn | currency }}</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" class="text-right"><b>Tax</b></td>
                                      <td class="text-right">{{ totalTaxDetailReturn | currency }}</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" class="text-right"><b>Total</b></td>
                                      <td class="text-right">{{ totalDetailReturn | currency }}</td>
                                      <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
          <div class="col-md-4"><pre>{{ dataCollect }}</pre></div>
          <div class="col-md-4"><pre>{{ salesReturn }}</pre></div>
          <div class="col-md-4"><pre>{{ sales }}</pre></div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios'
import { getHeader, productUrl, returnUrl, setQtyTotalUrl, sale2Url } from '../../config'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'SalesRetur',
  components: {
    Loading
  },
  props: ['sales'],
  data () {
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      taxList: state => state.taxes.taxList
    }),
    dataReturn () {
      return this.sales.returns[0]
    },
    salesReturn () {
      return this.sales.returns[0].details
    },
    totalSubtotalDetailReturn () {
      var sum = 0
      var array = this.sales.returns[0].details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].amount.replace(/\./g, '')) * parseFloat(array[i].qty)
      }
      return sum
    },
    totalTaxDetailReturn () {
      var sum = 0
      var array = this.sales.returns[0].details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax) * parseFloat(array[i].qty)
      }
      return sum
    },
    totalDetailReturn () {
      var sum = 0
      var array = this.sales.returns[0].details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    dataCollect () {
      var rtr = this.sales.returns[0]
      var detail = []
      var array = rtr.details.filter(d => d.product_no !== null)
      for (let i = 0; i < array.length; i++) {
        if (typeof array[i].id === 'undefined') {
          var obj = {
            return_no: null,
            product_no: array[i].product_no,
            product_sku: array[i].product_sku,
            serial_number: array[i].serial_number,
            uom_id: array[i].uom_id,
            qty: array[i].qty,
            amount: array[i].amount.replace(/\./g, ''),
            notes: array[i].notes,
            warehouse_no: array[i].warehouse_no,
            branch_no: array[i].branch_no,
            company_no: array[i].company_no,
            discount: array[i].discount,
            discount_percentage: array[i].discount_percentage,
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            total: array[i].total,
            return_date: null,
            cost: array[i].cost,
            cost_id: array[i].cost_id
          }
          detail.push(obj)
        } else {
          var obj2 = {
            id: array[i].id,
            return_no: array[i].return_no,
            product_no: array[i].product_no,
            product_sku: array[i].product_sku,
            serial_number: array[i].serial_number,
            uom_id: array[i].uom_id,
            qty: array[i].qty,
            amount: array[i].amount.replace(/\./g, ''),
            notes: array[i].notes,
            warehouse_no: array[i].warehouse_no,
            branch_no: array[i].branch_no,
            company_no: array[i].company_no,
            discount: array[i].discount,
            discount_percentage: array[i].discount_percentage,
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            total: array[i].total,
            return_date: null,
            cost: array[i].cost,
            cost_id: array[i].cost_id
          }
          detail.push(obj2)
        }
      }
      var data = {
        id: rtr.id,
        type: 'sales',
        return_no: null,
        return_date: rtr.return_date,
        deliver_date: rtr.deliver_date,
        vendor_no: null,
        purchasing_no: null,
        sale_no: this.sales.sale_no,
        notes: rtr.notes,
        status: rtr.status,
        branch_no: this.sales.branch_no,
        company_no: this.sales.company_no,
        lock: rtr.lock,
        is_deliver: rtr.is_deliver,
        customer_no: this.sales.customer_no,
        subtotal: rtr.subtotal,
        discount: rtr.discount,
        discount_percentage: rtr.discount_percentage,
        tax_id: rtr.tax_id,
        tax: rtr.tax,
        total: rtr.total,
        details: detail
      }
      return data
    }
  },
  methods: {
    async setCOGSAll () {
      var array = this.sales.returns[0].details
      for (let i = 0; i < array.length; i++) {
        var date = new Date(array[i].return_date)
        var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
        var data = {
          date: newDate,
          product_no: array[i].product_no,
          type: 'all',
          company_no: this.sales.company_no
        }
        console.log(data)
        await Axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            // this.$swal('Success', response.data.message, 'success')
          })
          .catch(error => {
            console.log(error)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    async setCOGS () {
      var array = this.sales.returns[0].details
      for (let i = 0; i < array.length; i++) {
        var date = new Date(array[i].return_date)
        var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
        var data = {
          date: newDate,
          product_no: array[i].product_no,
          type: 'retur sales',
          company_no: this.sales.company_no
        }
        await Axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            this.$swal('Success', response.data.message, 'success')
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    setTax () {
      var array = this.sales.returns[0].details
      var tax = this.taxList.find(d => d.id === this.sales.returns[0].tax_id)
      for (let i = 0; i < array.length; i++) {
        var qty = parseFloat(array[i].qty)
        var amount = parseFloat(array[i].amount.replace(/\./g, ''))
        var taxAmount = amount * parseFloat(tax.amount) / 100
        var total = qty * (amount + taxAmount)
        array[i].tax_id = this.sales.returns[0].tax_id
        array[i].tax = taxAmount
        array[i].taxes = tax.name
        array[i].total = total
      }
      this.sales.returns[0].subtotal = this.totalSubtotalDetailReturn
      this.sales.returns[0].tax = this.totalTaxDetailReturn
      this.sales.returns[0].total = this.totalDetailReturn
    },
    async updateRetur () {
      this.$Progress.start()
      this.loader.isLoading = true
      var resp = {
        error: false,
        message: null
      }
      await Axios.put(returnUrl + '/' + this.dataReturn.id, this.dataCollect, { headers: getHeader() })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          resp.error = false
          resp.message = error.response.data.message
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var array = this.dataCollect.details
      for (let i = 0; i < array.length; i++) {
        var code = array[i].product_no
        await this.setQtyTotal(code)
      }
      await this.setCOGSAll()
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', resp.message, 'success')
      await this.backParent()
    },
    async createRetur () {
      var resp = {
        error: false,
        message: null
      }
      await Axios.post(returnUrl, this.dataCollect, { headers: getHeader() })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          resp.error = false
          resp.message = error.response.data.message
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var array = this.dataCollect.details
      for (let i = 0; i < array.length; i++) {
        var code = array[i].product_no
        await this.setQtyTotal(code)
      }
      await this.setCOGS()
      await this.$swal('Success', resp.message, 'success')
      await this.backParent()
    },
    async createReturP () {
      var resp = {
        error: false,
        message: null
      }
      await Axios.post(returnUrl, this.dataCollect, { headers: getHeader() })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          resp.error = false
          resp.message = error.response.data.message
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      this.dataCollect.type = 'purchasing'
      await Axios.post(returnUrl, this.dataCollect, { headers: getHeader() })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          resp.error = false
          resp.message = error.response.data.message
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var array = this.dataCollect.details
      for (let i = 0; i < array.length; i++) {
        var code = array[i].product_no
        await this.setQtyTotal(code)
      }
      await this.setCOGS()
      await this.$swal('Success', resp.message, 'success')
      await this.backParent()
    },
    async createScrap () {
      var resp = {
        error: false,
        message: null
      }
      this.dataCollect.type = 'scrap'
      await Axios.post(returnUrl, this.dataCollect, { headers: getHeader() })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          resp.error = false
          resp.message = error.response.data.message
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var array = this.dataCollect.details
      for (let i = 0; i < array.length; i++) {
        var code = array[i].product_no
        await this.setQtyTotal(code)
      }
      await this.setCOGS()
      await this.$swal('Success', resp.message, 'success')
      await this.backParent()
    },
    async setQtyTotal (code) {
      var d = new Date()
      var n = d.getFullYear()
      var n1 = n - 1
      this.year = [n1, n]
      var newYear = d.getFullYear()
      var newMonth = d.getMonth() + 1
      var newDate = d.getDate()
      var newSetDate = newYear + '-' + newMonth + '-' + newDate
      var comNo = this.sales.company_no

      await Axios.get(setQtyTotalUrl + '?end=' + newSetDate + '&available=true&company_no=' + comNo + '&product_no=' + code, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    calcrow (index) {
      var detail = this.sales.returns[0].details[index]
      var qty = parseFloat(detail.qty)
      var amount = parseFloat(detail.amount.replace(/\./g, ''))
      var tax = parseFloat(detail.tax)
      var total = qty * (amount + tax)
      detail.total = total
      this.sales.returns[0].subtotal = this.totalSubtotalDetailReturn
      this.sales.returns[0].tax = this.totalTaxDetailReturn
      this.sales.returns[0].total = this.totalDetailReturn
    },
    removeReturn (index) {
      var rtr = this.sales.returns[0].details[index]
      if (typeof rtr.id === 'undefined') {
        this.sales.returns[0].details.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(returnUrl + '/detail/' + rtr.id, { headers: getHeader() })
              .then(response => {
                this.sales.returns[0].details.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    addToReturn (index) {
      var sdetail = this.sales.details[index]
      var tax = this.taxList.find(d => d.id === sdetail.tax_id)
      var returnDetail = this.sales.returns[0].details.find(d => d.product_no === sdetail.product_no)
      console.log('returnDetail')
      console.log(returnDetail)
      if (typeof returnDetail === 'undefined') {
        var totalRetur = parseFloat(sdetail.qty) * (parseFloat(sdetail.price.replace(/\./g, '')) + parseFloat(sdetail.tax))
        var obj = {
          return_no: null,
          product_no: sdetail.product_no,
          product: sdetail.description,
          product_sku: sdetail.product_sku,
          serial_number: null,
          uom_id: sdetail.uom_id,
          qty: sdetail.qty,
          amount: sdetail.price,
          cost: sdetail.cost,
          cost_id: sdetail.cost_id,
          notes: sdetail.notes,
          warehouse_no: sdetail.warehouse_no,
          warehouse: sdetail.warehouse,
          branch_no: sdetail.branch_no,
          company_no: sdetail.company_no,
          discount: '0',
          discount_percentage: '0',
          tax_id: sdetail.tax_id,
          tax: sdetail.tax,
          taxes: tax.name,
          total: totalRetur
        }
        this.sales.returns[0].details.push(obj)
      }

      this.sales.returns[0].subtotal = this.totalSubtotalDetailReturn
      this.sales.returns[0].tax = this.totalTaxDetailReturn
      this.sales.returns[0].total = this.totalDetailReturn
    },
    backParent () {
      this.$emit('backClicked')
    },
    printRetur () {
      window.open(sale2Url + '/print/' + this.sales.returns[0].id + '/return', '_blank')
    }
  }
}
</script>
